import * as React from "react";
import styled from "styled-components";

import { IconCaret, InputLabel, Text } from "../../../components/atoms";
import { theme } from "../../../theme";

interface IInputProps {
  isFocused: boolean;
  disabled?: boolean;
}

interface IProps extends IInputProps {
  onCodeSelect(value: string): void;
  onPhoneInput(value: string): void;
  onToggleFocus(): void;
  onWrapperClick(e: React.MouseEvent<HTMLDivElement>): void;
  phoneNumber: string;
  selectedCodeIndex: number;
  selectedDialCode: string;
  inputRef: React.RefObject<HTMLInputElement>;
  selectRef: React.RefObject<HTMLSelectElement>;
  children?: React.ReactNode;
}

const InputPhoneCodeSelector = styled.select`
  position: absolute;
  left: 0;
  width: 100%;
  border: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 1;

  &:disabled {
    cursor: default;
  }
`;

const InputPhoneCode = styled(Text)`
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 2px;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 9px;
    margin-left: 2px;
  }
`;

const InputPhoneWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 56px;
  padding: 24px 16px 14px 16px;
  border: solid 1px ${theme.color.inputBorderColor};
  background-color: #ffffff;
  cursor: text;
  transition: all ${theme.transition.easeInOut03};

  ${(props: IInputProps) =>
    props.isFocused
      ? `box-shadow: 0 0 0 1px ${theme.color.ruubyBlue}`
      : undefined}

  ${(props: IInputProps) =>
    props.disabled
      ? `background-color: ${theme.color.ruubyGreyLight}; cursor: default;`
      : undefined}
`;

const Input = styled.input`
  width: 100%;
  font-family: ${theme.fontName.main};
  font-size: ${theme.fontSize.smaller};
  font-weight: 700;
  background-color: #ffffff;
  color: ${theme.color.ruubyBlack};
  border: 0;
  box-shadow: none;
  outline: none;

  &:disabled {
    background-color: ${theme.color.ruubyGreyLight};
  }

  @media screen and (max-width: 992px) {
    font-size: ${theme.fontSize.bigger};
  }
`;

const InputPhone: React.FC<IProps> = (props) => {
  return (
    <InputPhoneWrapper
      isFocused={props.isFocused}
      disabled={props.disabled}
      onClick={props.onWrapperClick}
    >
      <InputLabel>Mobile number</InputLabel>
      <InputPhoneCode size="12" mobileSize="16" weight="semibold">
        <React.Fragment>
          <span>{props.selectedDialCode}</span>
          <InputPhoneCodeSelector
            innerRef={props.selectRef}
            value={props.selectedCodeIndex}
            onChange={(event) => props.onCodeSelect(event.currentTarget.value)}
            disabled={props.disabled}
          >
            {props.children}
          </InputPhoneCodeSelector>
          <IconCaret />
        </React.Fragment>
      </InputPhoneCode>
      <Input
        innerRef={props.inputRef}
        onBlur={props.onToggleFocus}
        onChange={(event) => props.onPhoneInput(event.currentTarget.value)}
        onFocus={props.onToggleFocus}
        value={props.phoneNumber}
        disabled={props.disabled}
      />
    </InputPhoneWrapper>
  );
};

export { InputPhone };
